module.exports = __webpack_public_path__ + "static/media/4_r_komp_one_78.65_63.24.d0901b97.png";